export const CENTS_IN_RAND = 100;
